// /src/Login/loginUtils.js

export const isValidMobile = (mobile) => /^\d{10}$/.test(mobile);
export const isValidOtp = (otp) => /^\d{6}$/.test(otp);

export const generateIdentityKeys = async () => {
  const identityKeyPair = await window.crypto.subtle.generateKey(
    { name: "ECDH", namedCurve: "P-256" },
    true,
    ["deriveKey"]
  );

  const exportedPriv = await window.crypto.subtle.exportKey(
    "pkcs8",
    identityKeyPair.privateKey
  );
  const exportedPub = await window.crypto.subtle.exportKey(
    "raw",
    identityKeyPair.publicKey
  );

  return {
    identityPrivateKeyBase64: window.btoa(String.fromCharCode(...new Uint8Array(exportedPriv))),
    identityPublicKeyBase64: window.btoa(String.fromCharCode(...new Uint8Array(exportedPub))),
  };
};

export const storeLoginData = ({ token, mobile, name }) => {
  localStorage.setItem("token", token);
  localStorage.setItem("mobile", mobile);
  localStorage.setItem("name", name);
  window.dispatchEvent(new Event("storage"));
};
